import { Box, Button, Divider } from '@mui/material';
import React from 'react';
import { useAppDispatch } from '../../../hooks';
import {
    closeDrawer,
    type DrawerOpenParams,
    openDrawer,
} from '../rightDrawerSlice';
import Comp from './Comp';

export type CompsProps = {
    sessionId: string
    episodeId: string
    // if opening a single existing comp
    compId?: string
    lineId?: string
    // to create a comp for the selected lines
    selectedLineIds?: string[]
    returnParams?: DrawerOpenParams
}

export default function Comps({ sessionId, episodeId, compId, lineId, selectedLineIds, returnParams }: CompsProps) {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(closeDrawer());
    }

    return (
        <>
            {returnParams && <Button onClick={() => dispatch(openDrawer(returnParams))}>Back</Button>}
            {selectedLineIds && selectedLineIds.map((lineId) => (
                <Box key={lineId}>
                    <Comp key={lineId} sessionId={sessionId} episodeId={episodeId} lineId={lineId} />
                    <Divider />
                </Box>
            ))}
            {compId && lineId && <Comp sessionId={sessionId} episodeId={episodeId} compId={compId} lineId={lineId} />}
            <Button onClick={handleClick}>Close</Button>
        </>
    )
}